import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const TOGGLE_EDIT_FORM_TYPE_MODAL = 'TOGGLE_EDIT_FORM_TYPE_MODAL';

function openEditFormTypeModal(formId, originalFileName, otherFormTypesInFamily) {
  return {
    type: TOGGLE_EDIT_FORM_TYPE_MODAL,
    isEditFormTypeModalShown: true,
    editingFormTypeId: formId,
    editingFormTypeOriginalFileName: originalFileName,
    editingFormTypeOtherFormTypesInFamily: otherFormTypesInFamily
  };
}

function closeEditFormTypeModal() {
  return {
    type: TOGGLE_EDIT_FORM_TYPE_MODAL,
    isEditFormTypeModalShown: false
  };
}

export function showEditFormTypeModal(formId, originalFileName, otherFormTypesInFamily) {
  return (dispatch) => {
    dispatch(openEditFormTypeModal(formId, originalFileName, otherFormTypesInFamily));
  };
}

export function hideEditFormTypeModal() {
  return (dispatch) => {
    dispatch(closeEditFormTypeModal());
  };
}

export function updateFormType(formId, newFormType, callback) {
  return (dispatch) => {
    const promise = () => ApiService
      .updateFormType(formId, newFormType)
      .then((response) => {
        const action = dispatch(closeEditFormTypeModal());
        if (callback) {
          callback();
        }
        return action;
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, closeEditFormTypeModal, true));
        }
      });
    return promise();
  };
}
